<template>
	<v-tabs-items :value="advanced" touchless>
		<v-tab-item>
			<roles @toggle="handleToggle" />
		</v-tab-item>
		<v-tab-item>
			<roles-advanced @toggle="handleToggle" />
		</v-tab-item>
	</v-tabs-items>
</template>

<script>
import { mapGetters } from "vuex";
import Roles from "./Roles";
import RolesAdvanced from "./RolesAdvanced";

export default {
	components: {
		Roles,
		RolesAdvanced,
	},

	data() {
		return {
			advanced: 0,
		};
	},

	computed: {
		...mapGetters("userEdit", ["canEdit"]),
	},

	watch: {
		canEdit(val) {
			if (!val) {
				this.advanced = 0;
			}
		},
	},

	methods: {
		handleToggle() {
			this.advanced = this.advanced ? 0 : 1;
		},
	},
};
</script>
